import { useEffect, useState } from "react";
import api from "../lib/api";
import { canSeeCustomers } from "../lib/customers";

// {prospect id: {phase, status}} of the customer accounts the person may see (Ordre 07, D-40): the « Client · … » mark on the
// pipeline cards and the prospects list. Nothing is fetched without the right; a failure only hides the marks.
export default function useCustomerBadges(user) {
  const enabled = canSeeCustomers(user);
  const [badges, setBadges] = useState({});
  useEffect(() => {
    if (!enabled) {
      setBadges({});
      return undefined;
    }
    let alive = true;
    api.get("/customers/badges").then(({ data }) => { if (alive) setBadges(data || {}); }).catch(() => { if (alive) setBadges({}); });
    return () => { alive = false; };
  }, [enabled]);
  return badges;
}
